import React, { useCallback, useLayoutEffect, useRef } from 'react'

import './Modal.scss'

export interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

let openModalCount = 0
let previousBodyOverflowY = ''
let previousBodyPaddingRight = ''

export const Modal = ({ isOpen, onClose, children }: ModalProps) => {
  const overlayRef = useRef<HTMLDivElement>(null)

  const handleOverlayClick = useCallback((e: React.MouseEvent) => {
    if (e.target === overlayRef.current) {
      onClose()
    }
  }, [onClose])

  useLayoutEffect(() => {
    if (!isOpen) return

    if (openModalCount === 0) {
      previousBodyOverflowY = document.body.style.overflowY
      previousBodyPaddingRight = document.body.style.paddingRight

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflowY = 'hidden'
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }

    openModalCount += 1

    return () => {
      openModalCount -= 1

      if (openModalCount === 0) {
        document.body.style.overflowY = previousBodyOverflowY
        document.body.style.paddingRight = previousBodyPaddingRight
      }
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div
      ref={overlayRef}
      className='modal-overlay'
      onClick={handleOverlayClick}
    >
      <div className='modal-content'>
        {children}
      </div>
    </div>
  )
}
